export class Blacklist{
    constructor(
        id?: number,
        login?: string,
        eleicaoId?: number,
    ){

    }
}
